import { jsx as o } from "react/jsx-runtime";
import { getIconStyles as l } from "../styles.js";
const t = (e) => /* @__PURE__ */ o(
  "svg",
  {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: l(e),
    children: /* @__PURE__ */ o(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M16.199 12.0117L5.98984 22.2208C5.59932 22.6114 5.59932 23.2445 5.98984 23.635C6.38037 24.0256 7.01353 24.0256 7.40406 23.635L17.7896 13.2495C17.952 13.0872 18.0814 12.8939 18.1694 12.6818C18.2574 12.4694 18.3027 12.2418 18.3027 12.0119C18.3027 11.782 18.2574 11.5544 18.1694 11.342C18.0814 11.13 17.9527 10.9374 17.7904 10.7751L17.7896 10.7743L7.40487 0.365785C7.01479 -0.025186 6.38163 -0.0259107 5.99065 0.364166C5.59968 0.754243 5.59896 1.38741 5.98904 1.77838L16.199 12.0117Z",
        fill: "currentColor"
      }
    )
  }
);
export {
  t as ChevronRightIcon
};
//# sourceMappingURL=ChevronRightIcon.js.map
